import React from 'react';
import {
  Box,
  Drawer,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  IconButton,
  Chip,
  Divider
} from '@mui/material';
import {
  Close as CloseIcon,
  Mic as MicIcon,
  MicOff as MicOffIcon,
  Videocam as VideocamIcon,
  VideocamOff as VideocamOffIcon,
  ScreenShare as ScreenShareIcon,
  PanTool as HandIcon,
  MoreVert as MoreIcon
} from '@mui/icons-material';

function ParticipantsPanel({ 
  open, 
  onClose, 
  participants, 
  localParticipant,
  isHost 
}) {
  const allParticipants = [
    { ...localParticipant, isLocal: true },
    ...participants
  ];

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDrawer-paper': {
          width: 320,
          bgcolor: '#2a2a2a',
          color: 'white'
        }
      }}
    >
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">
          Participants ({allParticipants.length})
        </Typography>
        <IconButton onClick={onClose} sx={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Divider sx={{ borderColor: '#444' }} />

      <List sx={{ flex: 1, overflow: 'auto' }}>
        {allParticipants.map((participant, index) => (
          <ListItem
            key={participant.participantId || 'local'}
            sx={{
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.05)'
              }
            }}
            secondaryAction={
              isHost && !participant.isLocal && (
                <IconButton edge="end" sx={{ color: 'white' }}>
                  <MoreIcon />
                </IconButton>
              )
            }
          >
            <ListItemAvatar>
              <Avatar
                sx={{
                  bgcolor: participant.role === 'host' ? 'primary.main' : '#1976d2'
                }}
              >
                {participant.displayName ? participant.displayName.charAt(0).toUpperCase() : '?'}
              </Avatar>
            </ListItemAvatar>

            <ListItemText
              primary={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="body1">
                    {participant.displayName}
                    {participant.isLocal && ' (You)'}
                  </Typography>
                  {participant.role === 'host' && (
                    <Chip
                      label="Host"
                      size="small"
                      color="primary"
                      sx={{ height: 20, fontSize: 10 }}
                    />
                  )}
                </Box>
              }
              secondary={
                <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
                  {participant.isMuted ? (
                    <MicOffIcon sx={{ fontSize: 16, color: 'error.main' }} />
                  ) : (
                    <MicIcon sx={{ fontSize: 16, color: 'success.main' }} />
                  )}
                  
                  {participant.isCameraOff ? (
                    <VideocamOffIcon sx={{ fontSize: 16, color: 'error.main' }} />
                  ) : (
                    <VideocamIcon sx={{ fontSize: 16, color: 'success.main' }} />
                  )}
                  
                  {participant.isScreenSharing && (
                    <ScreenShareIcon sx={{ fontSize: 16, color: 'primary.main' }} />
                  )}
                  
                  {participant.isHandRaised && (
                    <HandIcon sx={{ fontSize: 16, color: 'warning.main' }} />
                  )}
                </Box>
              }
              secondaryTypographyProps={{
                component: 'div',
                sx: { color: 'rgba(255, 255, 255, 0.7)' }
              }}
            />
          </ListItem>
        ))}
      </List>

      {isHost && (
        <>
          <Divider sx={{ borderColor: '#444' }} />
          <Box sx={{ p: 2 }}>
            <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              As host, you can manage participants using the menu icon.
            </Typography>
          </Box>
        </>
      )}
    </Drawer>
  );
}

export default ParticipantsPanel;
